import { defineMessages } from 'react-intl';

export const scope = 'axionimprovements.features.toplevelgroups';

export default defineMessages({

    add_group: {
        id: `${scope}.labels.add_group`,
        defaultMessage: 'Add group.',
    },
    update_group: {
        id: `${scope}.labels.add_group`,
        defaultMessage: 'Update group.',
    },
    delete_group: {
        id: `${scope}.labels.delete_group`,
        defaultMessage: 'Delete group.',
    },
    add_a_new_group: {
        id: `${scope}.labels.add_a_new_group`,
        defaultMessage: 'Add a new group.',
    },
    update_a_group: {
        id: `${scope}.labels.update_a_group`,
        defaultMessage: 'Update a group.',
    },
    could_not_update_group: {
        id: `${scope}.labels.could_not_update_group`,
        defaultMessage: 'Could not update the group.',
    },
    could_not_create_group: {
        id: `${scope}.labels.could_not_create_group`,
        defaultMessage: 'Could not create the group.',
    },
    edit_group: {
        id: `${scope}.labels.edit_group`,
        defaultMessage: 'Edit the group.',
    },
    groups: {
        id: `${scope}.labels.groups`,
        defaultMessage: 'Groups.',
    },
    btn_close: {
        id: `${scope}.labels.btn_close`,
        defaultMessage: 'Close.',
    },
    lbl_name: {
        id: `${scope}.labels.lbl_name`,
        defaultMessage: 'Name.',
    },
    delete: {
        id: `${scope}.labels.delete`,
        defaultMessage: 'Delete.',
    },
    yes: {
        id: `${scope}.labels.yes`,
        defaultMessage: 'Yes.',
    },
    no: {
        id: `${scope}.labels.no`,
        defaultMessage: 'No.',
    },
    could_not_delete_group: {
        id: `${scope}.labels.could_not_delete_group`,
        defaultMessage: 'Could not delete the organization.',
    },
    sure_delete_group: {
        id: `${scope}.labels.sure_delete_group`,
        defaultMessage: 'Are you sure you want to delete the organization.',
    },



});